import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

export interface AssetCountQuery {
  group_by?: string;
  date_received?: string;
  year_received?: string;
  is_assigned?: boolean;
  donor_id?: string;
  batch_id?: string;
}
const getAssetCount = async (queryParams: AssetCountQuery) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<Record<string, number>>(
    "get",
    `assets/analytics/count${query}`
  );
};

export const assetApiAnalytics = {
  getAssetCount,
};
